import { Component, inject, Input, OnInit } from '@angular/core';
import {ModalService} from '../../../../shared/services/modal.service';
import {TimesheetRow} from '../../model/timesheet-row';
import {ModalComponent} from '../../../../shared/components/modal/modal.component';

@Component({
  selector: 'app-confirm-delete-work-item-week-row',
  imports: [ModalComponent],
  templateUrl: './confirm-delete-work-item-week-row.component.html',
  styleUrl: './confirm-delete-work-item-week-row.component.css',
})
export class ConfirmDeleteWorkItemWeekRowComponent implements OnInit {
  private readonly modalService = inject(ModalService);

  @Input() data?: { row: TimesheetRow; onConfirm: (row: TimesheetRow) => void };
  row?: TimesheetRow;

  ngOnInit(): void {
    this.row = this.data?.row;
  }

  deleteRow() {
    if(this.row && this.data?.onConfirm) {
      this.data.onConfirm(this.data.row);
      this.modalService.close();
    }
  }
}
